import { Component, inject } from '@angular/core';
import { CreateSparkCampaign } from '../../../../../../service/create-spark-campaign/create-spark-campaign';

@Component({
  selector: 'ad-tracking-third-party-tracking',
  imports: [],
  templateUrl: './third-party-tracking.html',
  styleUrl: './third-party-tracking.css',
})
export class ThirdPartyTracking {
  public createSparkCampaignService = inject(CreateSparkCampaign);

  onImpressionTrackingUrlInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    const value = input?.value?.trim();
    this.createSparkCampaignService.impression_tracking_url.set(value ? value : undefined);
  }

  onClickTrackingUrlInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    const value = input?.value?.trim();
    this.createSparkCampaignService.click_tracking_url.set(value ? value : undefined);
  }
}
